import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  IonButton,
  IonItem,
  IonLabel,
  IonInput,
  IonPage,
  IonRow,
  IonCol,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid,
  IonSelect,
  IonSelectOption,
  IonBackButton,
  IonButtons,
  IonHeader,
  IonToolbar,
  NavContext,
  IonIcon,
  IonCheckbox,
  IonLoading,
  IonTitle,
  IonToggle,
} from "@ionic/react";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./provider.css";
import * as ApiService from "../../services/ApiService";
import * as Helper from "../../services/Helpers";
import { useForm, Controller } from "react-hook-form";
import { IUserProps } from "../../models/user";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { arrowBackCircleSharp } from "ionicons/icons";
import {
  IDashboardItems,
  IProvider,
  IProviderType,
} from "../../models/provider";
import { Redirect, useHistory, useLocation } from "react-router";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, CircularProgress, Input, List, ListItem, ListItemText, MobileStepper, Modal, Paper, Popover, Step, StepLabel, Stepper, TextareaAutosize, TextField, Typography } from "@mui/material";
import { APP_STATE_NAME } from "../../context/layout-context";
import { getUserAttributes } from "../../services/Helpers";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTheme } from '@mui/material/styles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../context/store";
import { fetchDashboardItems } from "../../context/reducer/Layoutreducer";
import { useTranslations } from "../../hooks/useTranslations";
import { label } from "aws-amplify";

var _ = require("lodash");

interface UserDataType {
  id: string;
  name: string;
  phone: number;
}

const dataArray: UserDataType = {
  name: '',
  phone: 0,
  id: "",
}

let initialValues: IProvider = {};

const dashboardItems = [
  "Breaches",
  "PatientList",
  "Charts",
  "Latest Ten Readings",
  "BillingCycle",
  "Reward Program",
  "Schedule Messages",
  "Survey Results",
  "Patients Pending Approval"
];
const readingEntry = ["Automatic", "Manual", "Automatic and Manual"];
const steps = ['Update Provider', 'Select Dashboard Items', 'Add Groups to Provider'];
const EMRTypes = ["Epic"];

const Provider: React.FC<any> = (props) => {
  const { userState, setUserState } = useContext(ApplicationContext);

  const [isProvider, setIsProvider] = React.useState(false);
  const { goBack } = useContext(NavContext);
  const location: any = useLocation();
  const history: any = useHistory();
  const [providerTypes, setTypes] = useState([]);
  const [providerId, setProviderId] = useState();

  const [loading, setLoading] = useState(false);
  const [providerData, setProviderData] = useState(null);

  const labels = useTranslations()

  const {
    register,
    control,
    handleSubmit,
    formState,
    reset,
    errors,
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: { ...initialValues },
    mode: "onChange",
  });

  const showError = (_fieldName: string) => {
    let error = (errors as any)[_fieldName];
    return error ? (
      <div style={{ color: "red", fontWeight: "bold" }}>
        {error.message || "Field Is Required"}
      </div>
    ) : null;
  };

  const [item, setCheckedItem] = useState(
    null
  );

  const [checkedState, setCheckedState] = useState(
    new Array(dashboardItems.length).fill(false)
  );

  const getProviderReadingMode = (readingEntry) => {
    if (readingEntry === 0) {
      return "Automatic";
    }

    if (readingEntry === 1) {
      return "Manual";
    }

    return "Automatic and Manual";
  };

  const { providerState } = useContext(ProviderContext)
  const dispatch: AppDispatch = useDispatch()

  useEffect(() => {
    fetchProviderType();
    if (location.state?.provider?.id) {
      fetchProviderDetails(location.state?.provider?.id);
    }
  }, [providerState.providerId]); // Fetch provider when providerId changes


  const fetchProviderDetails = async (providerId) => {
    try {
      let user = userState.authenticatedUser;
      let provider = location.state?.provider;

      if (!provider?.id) return; // Exit if provider ID is not available

      const updatedProvider = await ApiService.fetchProvider(user, providerId); // Fetch provider data

      setProviderData(updatedProvider);

      var readingMode = getProviderReadingMode(
        updatedProvider?.configuration?.activeReadingMode
      );

      let attr = getUserAttributes(user.signInUserSession["idToken"].jwtToken);
      setIsProvider(attr?.roles[0] === "Provider");

      if (updatedProvider !== undefined) {

        setValue("id", updatedProvider.id, {});
        setValue("providerCode", updatedProvider.providerCode, { shouldValidate: true });
        setValue("providerName", updatedProvider.providerName, { shouldValidate: true });
        setValue("medlineCustomerNumber", updatedProvider.medlineCustomerNumber, {
          shouldValidate: true,
        });
        setValue("phone", updatedProvider.phone, { shouldValidate: false });
        setValue("email", updatedProvider.email, { shouldValidate: false });
        setValue("tenantid", updatedProvider?.configuration?.clinRepoTenantId, { shouldValidate: false });
        setValue("patientBillingRate", updatedProvider?.configuration?.patientBillingRate, { shouldValidate: false });
        setValue("providerType", updatedProvider.providerType, {
          shouldValidate: true,
        });
        setValue(
          "configuration.daysInFirstPeriod",
          updatedProvider?.configuration?.daysInFirstPeriod,
          { shouldValidate: false }
        );
        setValue(
          "configuration.daysInSecondPeriod",
          updatedProvider?.configuration?.daysInSecondPeriod,
          { shouldValidate: false }
        );
        setValue(
          "configuration.daysInThirdPeriod",
          updatedProvider?.configuration?.daysInThirdPeriod,
          { shouldValidate: false }
        );
        setValue(
          "configuration.totalCycleDays",
          updatedProvider?.configuration?.totalCycleDays,
          { shouldValidate: false }
        );
        setValue(
          "configuration.clinRepoTenantId",
          updatedProvider?.configuration?.clinRepoTenantId,
          { shouldValidate: false }
        );
        setValue(
          "configuration.patientBillingRate",
          updatedProvider?.configuration?.patientBillingRate,
          { shouldValidate: true }
        );
        setValue(
          "configuration.billingName",
          updatedProvider?.configuration?.billingName,
          { shouldValidate: false }
        );
        setValue(
          "configuration.contractNumber",
          updatedProvider?.configuration?.contractNumber,
          { shouldValidate: false }
        );
        setValue(
          "configuration.breachRecheckNotification",
          updatedProvider?.configuration?.breachRecheckNotification,
          { shouldValidate: false }
        );

        setValue(
          "configuration.billToNumber",
          updatedProvider?.medlineCustomerNumber,
          { shouldValidate: false }
        );

        setValue("configuration.activeReadingMode", readingMode, {
          shouldValidate: false,
        });
        setValue(
          "emrType",
          updatedProvider?.emrType,
          { shouldValidate: false }
        );

        setProviderId(updatedProvider.id);

        updatedProvider.dashboardItems.forEach((d) => {
          checkedState[d.dashboardItemId - 1] = true;
        });

        setCheckedItem(updatedProvider.dashboardItems);
      }
    } catch (error) {
      console.error("Error fetching provider details:", error);
    }
  };

  const fetchProviderType: any = async () => {

    ApiService.fetchProviderTypes(userState.authenticatedUser).then((data) => {
      if (data) {
        setTypes(data);
      }
    });
  };

  const compareWith = (o1: IProviderType, o2: IProviderType) => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };

  const getActiveReadingMode = (readingEntry: any) => {
    if (readingEntry === "Automatic") {
      return 0;
    }

    if (readingEntry === "Manual") {
      return 1;
    }
    return 2;
  };

  const onSubmit = (data) => {
    let provider = providerData;
    var activeReadingMode = getActiveReadingMode(
      data.configuration.activeReadingMode
    )
    try {
      if (data.id === undefined) {
        setLoading(true);
        const providerConfigdata = {
          ...data.configuration,
          activeReadingMode: activeReadingMode,
        };

        const dataToSend = {
          ...data,
          configuration: providerConfigdata,
          dashboardItems: item,

        };

        ApiService.addProvider(userState.authenticatedUser, dataToSend)
          .then((result) => {
            setLoading(false);
            if (result) {
              alert("Added Sucessfully!");
              history.push("/providers");
            }
          })
          .catch((error) => {
            setLoading(false);
            alert(error.message);
            goBack();
          });

      } else {
        setLoading(true);
        const providerConfigdata = {
          ...data.configuration,
          id:
            provider.configuration === null ? null : provider.configuration?.id,
          totalCycleDays: totalCycle,
          activeReadingMode: activeReadingMode,
        };

        const dataToSend = {
          ...data,
          configuration: providerConfigdata,
          dashboardItems: item,
        };
        const statedata = { userState, providerState };

        ApiService.updateProvider(userState.authenticatedUser, dataToSend)
          .then((result) => {
            setLoading(false);
            if (result) {
              // localStorage.removeItem(
              //   APP_STATE_NAME + "_" + userState.authenticatedUser.username
              // );
              alert("Updated Sucessfully!");
              dispatch(fetchDashboardItems(statedata));
              history.push("/providers");
            }
          })
          .catch((error) => {
            setLoading(false);
            alert(error.message);
            goBack();
          });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  function onDeactivateProvider(a: any): void {
    let user = userState.authenticatedUser;
    let toUpdate = providerData;

    ApiService.deActivateProvider(user, toUpdate?.id)
      .then((response) => {
        alert("provider deactivated successfully");
        goBack();
      })
      .catch((err) => {
        alert('Something went wrong.');
      });
  }

  function onActivateProvider(a: any): void {
    let user = userState.authenticatedUser;
    let toUpdate = providerData;
    ApiService.activateProvider(user, toUpdate)
      .then((response) => {
        //
        alert("provider activated successfully");
        goBack();
      })
      .catch((err) => {
        alert(err);
      });
  }

  let totalCycle = 0;
  const firstDay: string = getValues("configuration.daysInFirstPeriod");
  const secondDay: string = getValues("configuration.daysInSecondPeriod");
  const thirdDay: string = getValues("configuration.daysInThirdPeriod");

  const watchFirst = watch("configuration.daysInFirstPeriod");
  const watchSecond = watch("configuration.daysInSecondPeriod");
  const watchThird = watch("configuration.daysInThirdPeriod");

  // Watch the `medlineCustomerNumber` field
  const medlineCustomerNumber = watch('medlineCustomerNumber');
  useEffect(() => {
    setValue('configuration.billToNumber', medlineCustomerNumber);
  }, [medlineCustomerNumber, setValue]);

  const calc = (firstDay, secondDay, thirdDay) => {
    totalCycle = parseInt(firstDay) + parseInt(secondDay) + parseInt(thirdDay);
    setValue("configuration.totalCycleDays", totalCycle);
  };

  if (firstDay && secondDay && thirdDay) {
    calc(firstDay, secondDay, thirdDay);
  }

  const validate = (value: string) => {
    const matches = value.match(
      /^(?:0\.(?:0[0-9]|[0-9]\d?)|[0-9]\d*(?:\.\d{1,2})?)(?:e[+-]?\d+)?$/
    );
    return matches?.length > 0 || "Not a Number";
  };

  const handleOnChange = (position, name) => {
    let provider = location.state.provider;

    const updatedCheckedState = checkedState.map((item, index) => {
      const isChecked = index === position ? !item : item;
      return isChecked;
    });

    var checkedItem = _.map(updatedCheckedState, (checked, index) => {
      return checked
        ? {
          providerId: provider.id,
          dashboardItemId: index + 1,
          provider: provider,
          dashboardItem: null,
        }
        : null;
    });

    var filterItem = _.filter(checkedItem, (d) => {
      return d !== null;
    });
    console.log("🚀 ~ handleOnChange ~ filterItem:", filterItem)

    setCheckedState(updatedCheckedState);
    setCheckedItem(filterItem);
  };

  return (
    <IonPage>
      <Header />
      <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text={labels.Goback}
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />
          </IonButtons>
          <IonTitle> {labels.Providers} {labels.details}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonCard>
                <IonCardHeader>
                  {/* <IonItem>
                    <IonLabel>
                      {location?.state?.provider?.id === undefined
                        ? "Create New"
                        : "Update"}{" "}
                      Provider
                    </IonLabel>
                  </IonItem> */}
                  <IonItem hidden={providerData?.id === undefined}>
                    {providerData?.isActive ? (
                      <IonButton
                        slot="end"
                        onClick={(a) => onDeactivateProvider(a)}
                      >
                        {labels.Deactivate}
                      </IonButton>
                    ) : (
                      <IonButton
                        slot="end"
                        onClick={(a) => onActivateProvider(a)}
                      >
                        {labels.Activated}
                      </IonButton>
                    )}
                  </IonItem>
                </IonCardHeader>
                <IonCardContent>


                  <IonRow>

                    <IonCol sizeXs="12" sizeSm="12" sizeLg="6" sizeMd="6">
                      <form
                        onSubmit={handleSubmit(onSubmit)}
                        style={{ padding: 18 }}
                      >
                        <Controller
                          render={({ onChange, onBlur, value }) => (
                            <IonInput
                              onIonChange={onChange}
                              slot="end"
                              hidden={true}
                              value={value}
                            />
                          )}
                          control={control}
                          name="id"
                          onChange={(e) => setValue("id", e.target.value)}
                          hidden={true}
                        />

                        <IonItem>
                          <IonRow>
                            <IonLabel> {labels.Providers} {labels.Name}  </IonLabel><IonLabel style={{ color: 'red', fontFamily: 'bold' }}>*</IonLabel>
                          </IonRow>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                disabled={isProvider}
                                value={value}
                              />
                            )}
                            control={control}
                            name="providerName"
                            onChange={(e) =>
                              setValue("providerName", e.target.value)
                            }
                            rules={{
                              required: true,
                            }}
                          />
                        </IonItem>

                        {/* {showError("providerName")} */}

                        <IonItem>
                          <IonRow>
                            <IonLabel>{labels.ProviderCode}  </IonLabel><IonLabel style={{ color: 'red', fontFamily: 'bold' }}>*</IonLabel>
                          </IonRow>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                disabled={providerId !== undefined}
                                value={value}
                              />
                            )}
                            control={control}
                            name="providerCode"
                            onChange={(e) =>
                              setValue("providerCode", e.target.value)
                            }
                            rules={{
                              required: true,
                            }}
                          />
                        </IonItem>
                        {/* {showError("providerCode")} */}
                        <IonItem>
                          <IonLabel> {labels.Email} </IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                value={value}
                              />
                            )}
                            control={control}
                            name="email"
                            onChange={(e) => setValue("email", e.target.value)}
                            rules={{
                              required: false,
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Invalid email address",
                              },
                            }}
                          />
                        </IonItem>
                        {showError("email")}
                        <IonItem>
                          <IonLabel> {labels.TenantId} </IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                value={value}
                                disabled={isProvider}
                              />
                            )}
                            control={control}
                            name="configuration.clinRepoTenantId"
                            onChange={(e) => setValue("configuration.clinRepoTenantId", e.target.value)}
                            rules={{
                              required: false,
                              // pattern: {
                              //   value:
                              //     /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              //   message: "Invalid email address",
                              // },
                            }}
                          />
                        </IonItem>
                        <IonItem>
                          <IonLabel>{labels.Phone}</IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value, name }) => (
                              <PhoneInput
                                international
                                placeholder="Enter phone number"
                                value={value}
                                defaultCountry="US"
                                onChange={onChange}
                                name={name}
                                slot="end"
                                className={'PhoneInputInput'}
                              />
                            )}
                            control={control}
                            name="phone"
                            onChange={(e) => setValue("phone", e.target.value)}
                            rules={{
                              required: false,
                            }}
                          />
                        </IonItem>
                        {showError("phone")}

                        <IonItem>
                          <IonLabel>{labels.DaysInFirstPeriod}</IonLabel>

                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                value={value}
                              />
                            )}
                            control={control}
                            name="configuration.daysInFirstPeriod"
                            onChange={(e) =>
                              setValue(
                                "configuration.daysInFirstPeriod",
                                e.target.value
                              )
                            }
                            rules={{
                              required: firstDay === "" ? true : false,
                            }}
                          />
                        </IonItem>

                        <IonItem>
                          <IonLabel>{labels.DaysInSecondPeriod}</IonLabel>

                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                value={value}
                              />
                            )}
                            control={control}
                            name="configuration.daysInSecondPeriod"
                            onChange={(e) =>
                              setValue(
                                "configuration.daysInSecondPeriod",
                                e.target.value
                              )
                            }
                            rules={{
                              required: secondDay === "" ? true : false,
                            }}
                          />
                        </IonItem>

                        <IonItem>
                          <IonLabel>{labels.DaysInThirdPeriod}</IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonInput
                                onIonChange={onChange}
                                slot="end"
                                value={value}
                              />
                            )}
                            control={control}
                            name="configuration.daysInThirdPeriod"
                            onChange={(e) =>
                              setValue(
                                "configuration.daysInThirdPeriod",
                                e.target.value
                              )
                            }
                            rules={{
                              required: thirdDay === "" ? true : false,
                            }}
                          />
                        </IonItem>

                        <IonItem>
                          <IonLabel style={{ color: "black" }}>
                            Total Cycle {labels.Days}
                          </IonLabel>
                          <IonInput
                            name="configuration.totalCycleDays"
                            slot="end"
                            disabled={true}
                            value={totalCycle}
                          />
                        </IonItem>

                        <IonItem>
                          <IonRow>
                            <IonLabel> {labels.Providers} {labels.Type}s </IonLabel><IonLabel style={{ color: 'red', fontFamily: 'bold' }}>*</IonLabel>
                          </IonRow>

                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonSelect
                                compareWith={compareWith}
                                value={value}
                                placeholder={labels.SelectOne}
                                onIonChange={onChange}
                                slot="end"
                                disabled={isProvider}
                              >
                                {providerTypes?.map((type) => (
                                  <IonSelectOption key={type.id} value={type}>
                                    {type.name}
                                  </IonSelectOption>
                                ))}
                              </IonSelect>
                            )}
                            control={control}
                            name="providerType"
                            onChange={(e) =>
                              setValue("providerType", e.target.value)
                            }
                            rules={{ required: true }}
                          />
                        </IonItem>

                        {/* {showError("providerType")} */}

                        <IonItem>
                          <IonLabel>EMR {labels.Type}s</IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonSelect
                                class="select-text"
                                value={value}
                                placeholder={labels.SelectOne}
                                onIonChange={onChange}
                                slot="end"
                              // disabled={isProvider}
                              >
                                {EMRTypes?.map((type, index) => (
                                  <IonSelectOption key={index} value={type}>
                                    {type}
                                  </IonSelectOption>
                                ))}
                              </IonSelect>
                            )}
                            control={control}
                            name="emrType"
                            onChange={(e) =>
                              setValue("emrType", e.target.value)
                            }
                          //rules={{ required: true }}
                          />
                        </IonItem>

                        <IonItem>
                          <IonLabel>{labels.ReadingEntryTypes}</IonLabel>
                          <Controller
                            render={({ onChange, onBlur, value }) => (
                              <IonSelect
                                class="select-text"
                                value={value}
                                placeholder={labels.SelectOne}
                                onIonChange={onChange}
                                slot="end"
                                disabled={isProvider}
                              >
                                {readingEntry?.map((type, index) => (
                                  <IonSelectOption key={index} value={type}>
                                    {type}
                                  </IonSelectOption>
                                ))}
                              </IonSelect>
                            )}
                            control={control}
                            name="configuration.activeReadingMode"
                            onChange={(e) =>
                              setValue(
                                "configuration.activeReadingMode",
                                e.target.value
                              )
                            }
                          //rules={{ required: true }}
                          />
                        </IonItem>
                        {!(userState?.authenticatedUser?.attributes['custom:Roles'] === 'Provider') && (
                          <IonItem>
                            <IonRow>
                              <IonLabel>{labels.MedlineCustomerNumber}</IonLabel>
                              <IonLabel> ({labels.BillTo}) </IonLabel>
                              <IonLabel style={{ color: 'red', fontFamily: 'bold' }}>*</IonLabel>
                            </IonRow>

                            <Controller
                              render={({ onChange, onBlur, value }) => (
                                <IonInput
                                  onIonChange={(e) => onChange(e.detail.value!)}
                                  slot="end"
                                  value={value}
                                  disabled={isProvider}
                                />
                              )}
                              control={control}
                              name="medlineCustomerNumber"
                              rules={{
                                required: true,
                              }}
                            />
                            {/* Hidden Field for billToNumber */}
                            <input
                              type="hidden"
                              {...(register('configuration.billToNumber') as unknown as Record<string, any>)}
                            />
                          </IonItem>
                        )}
                        {/* {showError("medlineCustomerNumber")} */}

                        {!(userState?.authenticatedUser?.attributes['custom:Roles'] === 'Provider') && (
                          <IonItem>
                            <IonLabel> {labels.ContractNumber} </IonLabel>
                            <Controller
                              render={({ onChange, onBlur, value }) => (
                                <IonInput
                                  onIonChange={onChange}
                                  slot="end"
                                  value={value}
                                  disabled={isProvider}
                                />
                              )}
                              control={control}
                              name="configuration.contractNumber"
                              onChange={(e) =>
                                setValue("configuration.contractNumber", e.target.value)
                              }
                            // rules={{
                            //   required: false,
                            // }}
                            />
                          </IonItem>
                        )}


                        {/* {showError("configuration.contractNumber")} */}

                        {!(userState?.authenticatedUser?.attributes['custom:Roles'] === 'Provider') && (
                          <IonItem>
                            <IonRow>
                              <IonLabel>{labels.PatientBillingRate}</IonLabel>
                              <IonLabel style={{ color: 'red', fontFamily: 'bold' }}>*</IonLabel>
                            </IonRow>
                            <div
                              slot="end"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end", // Align to the right
                                width: "120px", // Set a fixed or max width
                              }}
                            >
                              <span style={{ marginRight: "5px", fontSize: "16px", color: "#555" }}>$</span>
                              <Controller
                                render={({ onChange, value }) => (
                                  <IonInput
                                    onIonChange={onChange}
                                    disabled={isProvider}
                                    value={value}
                                    style={{
                                      textAlign: "left", // Align text inside input
                                      paddingLeft: "10px",
                                    }}
                                  />
                                )}
                                control={control}
                                name="configuration.patientBillingRate"
                                rules={{ required: true }}
                              />
                            </div>
                          </IonItem>
                        )}
                        {showError("configuration.patientBillingRate")}

                        <IonItem>
                          <IonLabel>{labels.RecheckBreachedNotification}</IonLabel>
                          <div
                            slot="end"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end", // Align to the right
                              width: "120px", // Set a fixed or max width
                            }}
                          >
                            <Controller
                              control={control}
                              name="configuration.breachRecheckNotification"
                              rules={{ required: false }}
                              render={({ onChange, value }) => (
                                <IonToggle
                                  // disabled={isProvider}
                                  checked={value} // Boolean field
                                  onIonChange={(e) => onChange(e.detail.checked)} // Convert event to boolean
                                />
                              )}
                            />
                          </div>
                        </IonItem>
                        <IonButton
                          type="submit"
                          disabled={formState.isValid === false}
                        >
                          {labels.Submit}
                        </IonButton>

                      </form>
                    </IonCol>

                    {!(userState?.authenticatedUser?.attributes['custom:Roles'] === 'Provider') && (
                      <IonCardContent>
                        <h1 style={{ color: "black", fontWeight: "bold" }}>
                          {labels.SelectDashboardItems}
                        </h1>
                        <IonCol>
                          {_.map(dashboardItems, (name, index) => {
                            return (
                              <IonItem>
                                <IonCheckbox
                                  checked={checkedState[index]}
                                  name={name}
                                  slot="start"
                                  onIonBlur={() => handleOnChange(index, name)}
                                ></IonCheckbox>
                                <IonLabel key={index}>{name}</IonLabel>
                              </IonItem>
                            )
                          })}
                        </IonCol>
                      </IonCardContent>
                    )}
                  </IonRow>

                  <IonLoading
                    cssClass="my-custom-class"
                    isOpen={loading}
                    onDidDismiss={() => setLoading(false)}
                    message={`${labels.Pleasewait}...`}
                    duration={5000}
                  />
                </IonCardContent>

              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage >
  );
};

export default Provider